import { css } from '@emotion/css';

import { Colors, LARGE_DEVICE_MQ } from 'apps/shared/scripts/styles/constants';

export const backButtonClassName = css({
  display: 'none',
  position: 'absolute',
  marginTop: 55,
  left: 0,
  height: 64,
  width: 64,
  color: Colors.Secondary,
  [LARGE_DEVICE_MQ]: {
    display: 'block',
  }
});

export const iconClassName = css({
  height: 20,
  width: 20,
});
